/**
 * Values baked in at build time.
 *
 * `__BUILD_YEAR__` is injected by DefinePlugin in craco.config.js. The footer's
 * copyright year has to come from here rather than from `new Date()`: marketing
 * pages are prerendered and then hydrated, so a value read from the clock would
 * disagree with the snapshot across a New Year boundary and cost us the whole
 * prerender until the next deploy. A build-time year is also what every static
 * site generator emits.
 *
 * The `typeof` guard covers Jest, which does not run the webpack define.
 */
declare const __BUILD_YEAR__: string | undefined;

export const BUILD_YEAR: string =
    typeof __BUILD_YEAR__ === 'string' ? __BUILD_YEAR__ : String(new Date().getFullYear());
